import React from 'react';

const Content = ({ post }) => {
  return (
    <div
      className="prose mt-6 max-w-none rounded-md border border-slate-200 bg-white px-5 py-6 text-lg leading-[1.75] text-gray-700 shadow-sm prose-headings:text-gray-900 prose-a:text-[rgb(126,34,206)] prose-a:no-underline hover:prose-a:underline sm:px-7"
      dangerouslySetInnerHTML={{ __html: post.content }}
    />
  );
};

export default Content;
